<div *ngFor="let step of stepsAmount; let i = index"
     class="{{ (active == i ? 'dot dot-active' : 'dot') }}"
></div>
